import script from "./IOrderMenuNew.vue?vue&type=script&setup=true&lang=js"
export * from "./IOrderMenuNew.vue?vue&type=script&setup=true&lang=js"

import "./IOrderMenuNew.vue?vue&type=style&index=0&id=afdcceea&lang=scss"

const __exports__ = script;

export default __exports__